import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { SpinnerStyles } from "./styles";
export var Spinner = forwardRef(function Spinner(_a, ref) {
    var color = _a.color, size = _a.size, props = __rest(_a, ["color", "size"]);
    return _jsx(SpinnerStyles, __assign({ ref: ref, size: size, color: color }, props));
});
//# sourceMappingURL=index.js.map